module.exports = __webpack_public_path__ + "static/media/logo-min.b7c0e3b0.png";